<template>
  <div class="flex-box align-center">
    <a-time-picker v-model="start" format="HH:mm" value-format="HH:mm" placeholder="开始时间" @change="dispatchEvent" />
    <div class="time-range-gap">至</div>
    <a-time-picker v-model="end" format="HH:mm" value-format="HH:mm" placeholder="结束时间" @change="dispatchEvent" />
  </div>
</template>

<script>
export default {
  name: "time-range",
  model: {
    event: 'change'
  },
  props: {
    value: Array
  },
  data() {
    return {
      start: null,
      end: null,
    }
  },
  watch: {
    value() {
      this.setValue();
    },
  },
  created() {
    this.setValue();
  },
  methods: {
    setValue() {
      let value = this.value;
      if(value) {
        this.start = value[0];
        this.end = value[1];
      }
    },
    dispatchEvent() {
      let start = this.start;
      let end = this.end;
      if(start && end) {
        this.$emit("change", [start, end]);
      } else {
        this.$emit("change", null);
      }
    }
  }
}
</script>

<style scoped lang="less">
  .time-range-gap {
    margin: 0 10px;
  }
</style>
